import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import { initMotion } from "./app/motion";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";

// Before the first paint, so a person who turned motion off never sees a pop-in.
initMotion();

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root element");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
